import { Link_default } from "./chunk-TK6RORJT.js";
import { __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Link/LinkAsButton.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var LinkAsButton = forwardRef((props, ref) => /* @__PURE__ */jsx(Link_default, __spreadProps(__spreadValues({
  ref
}, props), {
  as: "button"
})));
var LinkAsButton_default = LinkAsButton;
export { LinkAsButton_default };